export default "__VITE_ASSET__DcGdZ8y5__"